import axios from "axios";
import config from "./config";

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  headers: {
    "Content-Type": "application/json"
  }
});

// 🔥 Add an interceptor to include token automatically
axiosInstance.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// 🔥 Global error handling interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    switch (status) {
      case 400:
        error.message = error.response?.data?.message || "Bad Request";
        break;
      case 404:
        error.message = error.response?.data?.message || "Not Found (404)";
        break;
      case 500:
        error.message = "Server Error! Please try again after sometime.";
        break;
      default:
        error.message = "Something went wrong! Please try again";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;